export const NonAuthRoutes = ['/callback', '/offer-review']
